(() => {
  if (window.BsrCollectionReturnCache) return;
  const KEY = 'bsrCollectionReturnCache:v1';
  const TTL = 120000;
  const LIMIT = 3 * 1024 * 1024;
  const script = document.getElementById('bsr-collection-return-cache');
  let context = null;
  try { context = JSON.parse(script?.dataset.context || 'null'); } catch (_) {}
  const validContext = context && ['locale', 'country', 'currency', 'market', 'theme'].every((key) => String(context[key] || '').trim());
  const identity = () => validContext ? JSON.stringify({ context, url: location.origin + location.pathname + location.search, width: innerWidth, height: innerHeight }) : '';
  const target = () => {
    try {
      const value = JSON.parse(localStorage.getItem('bsrCollectionProductReturn:v2') || 'null');
      return value?.pending && value.sourceUrl === location.pathname + location.search + location.hash && Date.now() - value.savedAt <= TTL ? value : null;
    } catch (_) { return null; }
  };
  const productUrl = (value) => {
    try {
      const url = new URL(value, location.origin);
      return url.origin === location.origin && /\/products\/[^/]+/.test(url.pathname) ? url.pathname + url.search : '';
    } catch (_) { return ''; }
  };
  const sanitize = (html, liveCard = null) => {
    const template = document.createElement('template');
    template.innerHTML = html;
    template.content.querySelectorAll('noscript').forEach((node) => node.remove());
    const liveImages = liveCard ? Array.from(liveCard.querySelectorAll('img')) : [];
    template.content.querySelectorAll('img').forEach((image, index) => {
      const liveImage = liveImages[index];
      const canonical = liveImage?.getAttribute('data-src') || image.getAttribute('data-src');
      const selected = canonical || liveImage?.currentSrc || liveImage?.getAttribute('src') || image.getAttribute('src');
      if (!selected || !/^(https?:|\/)/i.test(selected)) return;
      image.setAttribute('src', selected);
      image.classList.remove('lazyload', 'lazyloading');
      image.classList.add('lazyloaded');
      ['srcset', 'sizes', 'data-src', 'data-srcset', 'data-sizes'].forEach((name) => image.removeAttribute(name));
      image.closest('picture')?.querySelectorAll('source').forEach((source) => source.remove());
    });
    template.content.querySelectorAll('script,style,link,iframe,object,embed,form,button,input,select,textarea,quickview-opener,[data-quickbuy-wrapper],.card-product__quickbuy,.card-product__quickbuy-options,.card-product__callout,[data-quickview-callout],.media__loader,template').forEach((node) => node.remove());
    const allowed = new Set(['DIV', 'SPAN', 'A', 'IMG', 'PICTURE', 'SOURCE', 'P', 'S', 'DEL', 'INS', 'SMALL', 'STRONG', 'EM', 'UL', 'LI', 'H2', 'H3', 'H4', 'BR']);
    Array.from(template.content.querySelectorAll('*')).forEach((node) => {
      if (!template.content.contains(node)) return;
      if (!allowed.has(node.tagName)) {
        const replacement = document.createElement('div');
        replacement.className = node.className?.baseVal || node.className || '';
        if (node.matches('card-product')) replacement.classList.add('card-product');
        replacement.append(...node.childNodes);
        node.replaceWith(replacement);
        node = replacement;
      }
      const paddingTop = node.style.paddingTop;
      Array.from(node.attributes).forEach((attribute) => {
        if (!['class', 'href', 'src', 'srcset', 'sizes', 'alt', 'width', 'height', 'loading', 'decoding', 'media', 'type', 'data-src', 'data-srcset', 'data-sizes', 'data-product-url', 'data-image-primary', 'data-image-secondary'].includes(attribute.name)) node.removeAttribute(attribute.name);
      });
      if (/^\d+(\.\d+)?%$/.test(paddingTop)) node.style.paddingTop = paddingTop;
      if (node.tagName === 'A') {
        const href = productUrl(node.getAttribute('href'));
        if (href) node.setAttribute('href', href);
        else node.removeAttribute('href');
      }
      ['src', 'data-src'].forEach((name) => {
        const value = node.getAttribute(name);
        if (value && !/^(https?:|\/)/i.test(value)) node.removeAttribute(name);
      });
    });
    const walker = document.createTreeWalker(template.content, 4);
    const whitespace = [];
    while (walker.nextNode()) {
      const node = walker.currentNode;
      if (!node.textContent.trim() && node.parentElement?.children.length) whitespace.push(node);
    }
    whitespace.forEach((node) => {
      if (node.parentElement.closest('.price')) node.textContent = ' ';
      else node.remove();
    });
    return template.content;
  };
  const serializeCards = (grid) => Array.from(grid.children).map((card) => {
    const content = sanitize(card.outerHTML, card);
    const holder = document.createElement('div');
    holder.append(content);
    return { html: holder.innerHTML, height: card.getBoundingClientRect().height, className: card.className, url: productUrl(card.dataset.productUrl || card.querySelector('a[href*="/products/"]')?.href) };
  });
  const read = (type, id) => {
    if (performance.getEntriesByType('navigation')[0]?.type !== 'back_forward' || !identity()) return null;
    try {
      const entry = JSON.parse(sessionStorage.getItem(KEY) || 'null');
      if (!entry || entry.version !== 1 || entry.identity !== identity() || entry.type !== type || entry.id !== id || !Number.isFinite(entry.time) || Date.now() < entry.time || Date.now() - entry.time > TTL) return null;
      return entry.payload;
    } catch (_) { return null; }
  };
  const save = (type, id, payload) => {
    if (!identity()) return false;
    try {
      const value = JSON.stringify({ version: 1, identity: identity(), type, id, payload, time: Date.now() });
      if (value.length * 2 > LIMIT) { sessionStorage.removeItem(KEY); return false; }
      sessionStorage.setItem(KEY, value);
      return true;
    } catch (_) { try { sessionStorage.removeItem(KEY); } catch (_) {} return false; }
  };
  const restoreCards = (grid, rows, targetHandle = '') => {
    if (!Array.isArray(rows) || rows.length > 2000 || rows.some((row) => typeof row.html !== 'string' || !Number.isFinite(row.height) || row.height < 0 || row.height > 10000)) throw new Error('Invalid cached cards.');
    const fragment = document.createDocumentFragment();
    const placeholders = rows.map((row) => {
      const node = document.createElement('div');
      node.className = row.className || '';
      node.dataset.bsrCachePlaceholder = 'true';
      node.style.display = 'block';
      node.style.height = row.height + 'px';
      fragment.append(node);
      return node;
    });
    grid.replaceChildren(fragment);
    const targetIndex = Math.max(0, rows.findIndex((row) => row.url?.split('?')[0].split('/products/')[1] === targetHandle));
    const materialize = (index) => {
      const placeholder = placeholders[index];
      if (!placeholder?.isConnected || placeholder.parentElement !== grid) return;
      const content = sanitize(rows[index].html);
      const card = content.firstElementChild;
      if (!card) return;
      card.classList.add('card-product');
      card.dataset.productUrl = productUrl(rows[index].url);
      card.dataset.bsrCachedCard = 'true';
      placeholder.replaceWith(card);
    };
    const near = new Set();
    for (let index = Math.max(0, targetIndex - 12); index <= Math.min(rows.length - 1, targetIndex + 12); index++) { near.add(index); materialize(index); }
    const remaining = rows.map((_, index) => index).filter((index) => !near.has(index));
    const complete = new Promise((resolve) => {
      const batch = () => {
        if (!grid.isConnected || !remaining.length) { resolve(); return; }
        remaining.splice(0, 24).forEach(materialize);
        if (remaining.length) requestAnimationFrame(batch); else resolve();
      };
      requestAnimationFrame(batch);
    });
    return { targetReady: Promise.resolve(), complete };
  };
  window.BsrCollectionReturnCache = { read, save, serializeCards, restoreCards, target, identity };
})();
